// extracted by mini-css-extract-plugin
export default {"imageWrapper":"WE-z","hovered":"XE-z","hoverImage":"YE-z","mainImage":"ZE-z","imageNoBackground":"_E-z","fullSizeImage":"aF-z"};